import React from 'react';
import PropTypes from 'prop-types';

import SurveySectionPageNumber from 'components/SurveySectionPageNumber';
import firstEmpty from 'utils/firstEmpty';
import {
  ALIGNMENT_TYPE_CENTER,
  ALIGNMENT_TYPE_LEFT,
  ALIGNMENT_TYPE_RIGHT,
} from 'sharedParts/constants/alignmentType';

import {
  columnCenter,
  columnLeft,
  columnRight,
  container,
} from './PageBreak.scss';

const PageBreak = ({
  backButton,
  backButtonAlignment,
  nextButton,
  nextButtonAlignment,
  pageNumber,
}) => {
  const {
    leftColumn,
    centerColumn,
    rightColumn,
  } = PageBreak.scatterPageBreakElementsByColumns({
    backButton,
    backButtonAlignment,
    nextButton,
    nextButtonAlignment,
    pageNumber: pageNumber ? (
      <SurveySectionPageNumber number={pageNumber} key="page-number" />
    ) : null,
  });

  return (
    <div className={container}>
      <div className={columnLeft}>{leftColumn}</div>
      <div className={columnCenter}>{centerColumn}</div>
      <div className={columnRight}>{rightColumn}</div>
    </div>
  );
};

PageBreak.propTypes = {
  backButton: PropTypes.object,
  backButtonAlignment: PropTypes.string,
  nextButton: PropTypes.object,
  nextButtonAlignment: PropTypes.string,
  pageNumber: PropTypes.number,
};

PageBreak.defaultProps = {
  backButton: null,
  backButtonAlignment: ALIGNMENT_TYPE_LEFT,
  nextButton: null,
  nextButtonAlignment: ALIGNMENT_TYPE_RIGHT,
  pageNumber: 0,
};

PageBreak.scatterPageBreakElementsByColumns = ({
  backButton,
  backButtonAlignment,
  nextButton,
  nextButtonAlignment,
  pageNumber,
}) => {
  const columns = {
    [ALIGNMENT_TYPE_CENTER]: [],
    [ALIGNMENT_TYPE_LEFT]: [],
    [ALIGNMENT_TYPE_RIGHT]: [],
  };
  const backButtonRelatedColumn = columns[backButtonAlignment];
  backButtonRelatedColumn.push(backButton);

  const nextButtonRelatedColumn = columns[nextButtonAlignment];
  nextButtonRelatedColumn.push(nextButton);

  const pageNumberRelatedColumn = firstEmpty([
    columns[ALIGNMENT_TYPE_LEFT],
    columns[ALIGNMENT_TYPE_RIGHT],
    columns[ALIGNMENT_TYPE_CENTER],
  ]);
  pageNumberRelatedColumn.push(pageNumber);

  return {
    centerColumn: columns[ALIGNMENT_TYPE_CENTER],
    leftColumn: columns[ALIGNMENT_TYPE_LEFT],
    rightColumn: columns[ALIGNMENT_TYPE_RIGHT],
  };
};

export default PageBreak;
